import { render, staticRenderFns } from "./AwaitingProjects.vue?vue&type=template&id=a4ec40a2"
import script from "./AwaitingProjects.vue?vue&type=script&lang=js"
export * from "./AwaitingProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports